import {
  type LowerHex,
  type TransactionDetail,
  getTransactionDetail,
} from '@pkg/evm'
import type {
  FetchEvmTransactionsParameters,
  FetchEvmTransactionsReturnTypes,
} from './types'

export const fetchEvmTransactions = async ({
  chain,
  indexes,
  internalTransactionList,
  onFetched,
}: FetchEvmTransactionsParameters): Promise<FetchEvmTransactionsReturnTypes> => {
  const transactions: TransactionDetail[] = []
  const errors = new Map<LowerHex, unknown>()
  await Promise.all(
    indexes.map(({ hash, timestamp }) =>
      (async () => {
        try {
          const transaction = await getTransactionDetail({
            chain,
            hash,
            timestamp,
            internalTransactions: internalTransactionList.filter(
              (internalTransaction) => internalTransaction.txHash === hash,
            ),
            timeout: 1000 * 60 * 30,
          })
          transactions.push(transaction)
        } catch (error) {
          errors.set(hash, error)
        } finally {
          onFetched(hash)
        }
      })(),
    ),
  )
  return {
    transactions,
    errors,
  }
}
